import type { ReactNode } from "react";
import { FileText, FolderKey, MessageSquare } from "lucide-react";
import { DialogDescription, DialogHeader, DialogTitle } from "../../ui/dialog";

export function RequestDetailsHeader({
  icon,
  title,
  children,
}: {
  icon: ReactNode;
  title: ReactNode;
  children: ReactNode;
}) {
  return (
    <DialogHeader className="request-details-header">
      <span className="request-details-platform-icon" aria-hidden="true">
        {icon}
      </span>
      <div className="request-details-heading">
        <DialogTitle>{title}</DialogTitle>
        <DialogDescription>{children}</DialogDescription>
      </div>
    </DialogHeader>
  );
}

export function RequestDetailsSection({
  title,
  variant = "resource",
  children,
}: {
  title: string;
  variant?: "request" | "resource" | "justification";
  children: ReactNode;
}) {
  const Icon =
    variant === "request"
      ? FileText
      : variant === "justification"
        ? MessageSquare
        : FolderKey;

  return (
    <section className={`request-details-section request-details-${variant}`}>
      <h3>
        <Icon aria-hidden="true" />
        {title}
      </h3>
      {children}
    </section>
  );
}
